export default {
    password_manteiners: process.env.VUE_APP_PASSWORD_MAINTEINERS,
    // Cubicador v2 (reserva consolidada + aprobación): only enabled in the environments listed
    // here, so the v2 UI ships dark to pre/prod and the v1 flow stays untouched. To turn it on,
    // add "preproduction" and/or "production" (VUE_APP_ENVIROMENT values) to this list.
    cubicador_v2: ["development"].includes(process.env.VUE_APP_ENVIROMENT),
}